import React from 'react';
import { isNewUIEnabled } from 'hooks/useNewUI';
import NotificationsNew from './NotificationsNew';
import NotificationsClassic from './NotificationsClassic';

// Classic (production) UI is the default. Only allow-listed users who opted
// into the new UI get the dark-glass notification popover; everyone else keeps
// the legacy white dropdown and the legacy (visible) bell icon.
export default function NotificationsComponent(props) {
  return isNewUIEnabled()
    ? <NotificationsNew {...props} />
    : <NotificationsClassic {...props} />;
}
